import i18next from 'i18next';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Table } from 'datastake-daf/dist/components';
import { useMemo } from 'react';

export const getLocales = (t) => ({
  triggerDesc: t('Click to sort descending'),
  triggerAsc: t('Click to sort ascending'), 
});

export default function DafTable({
  columns = [],
  data = [],
  defaultFilters = {},
  style = {},
  pagination = null,
  loading = false,
  onChange = () => { },
  setShowFilters,
  onFilterChange = () => { },
  selectOptions,
  filtersConfig,
  rowSelection = false,
  rowKey = 'id',
  showFilters = false,
  hideOnLoading = true,
  sourcesKey,
  className,
  doEmptyRows = false,
  ...rest
}) {
  const { t } = useTranslation();
  const { projects } = useSelector((state) => state.project.data);
  const { selectedProject, sourceId } = useSelector((state) => state.authentication);
  const { sources: projectSources } = useSelector((state) => state.project);

  const dataSource = useMemo(() => {
    if (doEmptyRows && pagination.pageSize) {
      const emptyDataSource = [];

      for (let i = 0; i < pagination.pageSize; i++) {
        emptyDataSource.push({ id: i, empty: true, key: i });
      }

      return emptyDataSource.map((empty, i) => data[i] || empty);
    }
    return data;
  }, [data, pagination]);

  return (
    <Table
      setShowFilters={setShowFilters}
      columns={columns}
      data={dataSource}
      defaultFilters={defaultFilters}
      style={style}
      pagination={pagination}
      loading={loading}
      onChange={onChange}
      onFilterChange={onFilterChange}
      selectOptions={selectOptions}
      filtersConfig={filtersConfig}
      rowSelection={rowSelection}
      rowKey={rowKey}
      showFilters={showFilters}
      hideOnLoading={hideOnLoading}
      sourcesKey={sourcesKey}
      className={className}
      t={t}
      projects={projects}
      selectedProject={selectedProject}
      sourceId={sourceId}
      projectSources={projectSources}
      language={i18next.language}
      locale={getLocales(t)}
      {...rest}
    />
  );
}
